<template>
  <div class="mt-8 flex justify-start">
    <h4 class="w-1/5 text-gray-600 font-semibold">Fund Information</h4>
    <div class="w-3/5">
      <h4 class="font-bold">{{ fund.details.name }}</h4>
      <h4 v-if="fund.details.contactNumber !== undefined">
        {{ fund.details.contactNumber }}
      </h4>
      <p v-if="fund.details.address !== undefined">
        {{ fund.details.address.line1 }}<br/>
        {{ fund.details.address.city }}
        {{ fund.details.address.state }}
        {{ fund.details.address.postal_code }}<br/>
        {{ fund.details.address.country }}
      </p>
      <table class="mt-6 w-full ">
        <tr>
          <!-- eslint-disable-next-line max-len -->
          <td class="border px-4 py-2 uppercase tracking-wider text-sm font-bold text-gray-600">Trustee Type</td>
          <td class="border px-4 py-2">
            <span class="font-bold">{{ fund.trustee.type | capitalize }}</span>
          </td>
        </tr>
        <tr
          v-if="fund.trustee.type === 'corporate'"
          class="bg-gray-100"
        >
          <!-- eslint-disable-next-line max-len -->
          <td class="border px-4 py-2 uppercase tracking-wider text-sm font-bold text-gray-600">Corporate Trustee</td>
          <td class="border px-4 py-2">
            <span>{{ fund.trustee.company.name }}</span>
          </td>
        </tr>
        <tr :class="{'bg-gray-100' : fund.trustee.type !== 'corporate'}">
          <!-- eslint-disable-next-line max-len -->
          <td class="border px-4 py-2 uppercase tracking-wider text-sm font-bold text-gray-600">Members</td>
          <td class="border px-4 py-2">
            <ul>
              <li
                v-for="(member,idx) in fund.members"
                :key="idx"
                class="leading-tight text-gray-600"
              >
                {{ member.firstName }} {{ member.lastName }}
              </li>
            </ul>
          </td>
        </tr>
        <tr
          :class="{'bg-gray-100' : fund.trustee.type === 'corporate'}"
        >
          <!-- eslint-disable-next-line max-len -->
          <td class="border px-4 py-2 uppercase tracking-wider text-sm font-bold text-gray-600">
            {{ fund.trustee.type === 'corporate' ? 'Directors' : 'Trustees' }}
          </td>
          <td class="border px-4 py-2">
            <ul>
              <li
                v-for="(trustee,idx) in fund.trustee.trustees"
                :key="idx"
                class="leading-tight text-gray-600"
              >
                {{ trustee.firstName }} {{ trustee.lastName }}
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
    <div class="w-1/5 self-end text-right">
      <m-button
        v-if="canEdit"
        @click="$router.push('/fund/information')"
      >Review</m-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fund-information',
  props: {
    fund: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>

</style>
